import { render, staticRenderFns } from "./basic-info-section.vue?vue&type=template&id=121d85ed&scoped=true&lang=pug&"
import script from "./basic-info-section.vue?vue&type=script&lang=ts&"
export * from "./basic-info-section.vue?vue&type=script&lang=ts&"
import style0 from "./basic-info-section.vue?vue&type=style&index=0&id=121d85ed&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121d85ed",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VForm,VProgressCircular})
